import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {showAppLoader, hideAppLoader} from 'app/Components/Shared/Loader/LoaderSlice';
import {DomainMarketCode, getMarketCode} from 'app/utilities/domain/domainConstants';

const checkCanRenderPortals = (marketCode = getMarketCode()) => {
  return marketCode != DomainMarketCode.GOLAN;
};

export const getContactCompanyList = createAsyncThunk('BussinessCustomer/getContactCompanyList', async (thunkAPI) => {
  try {
    var result = await ProviderManager.getProviderData('getContactCompanyList', []);
    return result.Body;
  } catch (error) {
    return {
      error: true,
    };
  }
});
export const getCcrReport = createAsyncThunk('BussinessCustomer/getCcrReport', async (data, thunkAPI) => {
  try {
    var result = await ProviderManager.getProviderData('getCcrReport', [
      data.orgId ? data.orgId : '',
      data.selectedNumber,
      data.eMail,
      data.dates,
    ]);
    return result.Body;
  } catch (error) {
    return {
      error: true,
    };
  }
});
export const GetCustomerDetailsForBusinessContactManager = createAsyncThunk(
  'BussinessCustomer/GetCustomerDetailsForBusinessContactManager',
  async (data, thunkAPI) => {
    try {
      var result = await ProviderManager.getProviderData('GetCustomerDetailsForBusinessContactManager', [
        data.orgId ? data.orgId : '',
        data.customerNumber,
        data.formType,
      ]);
      return result.Body;
    } catch (error) {
      return {
        error: true,
      };
    }
  },
);

export const suspendOrActivateBusinessAccount = createAsyncThunk(
  'BussinessCustomer/SuspendOrActivateBusinessAccountManager',
  async (data, thunkAPI) => {
    try {
      var result = await ProviderManager.getProviderData('SuspendOrActivateBusinessAccount', [
        data.orgId ? data.orgId : '',
        data.selectedNumber,
        data.action,
        data.reason,
        data.canDoAction,
        data.msgCode ? data.msgCode : '',
        data.msg ? data.msg : '',
        data.formType,
      ]);
      return result.Body;
    } catch (error) {
      return {
        error: true,
      };
    }
  },
);

export const ChangeSim = createAsyncThunk('BussinessCustomer/ChangeSim', async (data, thunkAPI) => {
  try {
    var result = await ProviderManager.getProviderData('ChangeSim', [data.orgId ? data.orgId : '', data.phoneNumber, data.newSimNumber]);
    return result.Body;
  } catch (error) {
    return {
      error: true,
    };
  }
});
export const GetDataUsage = createAsyncThunk('BussinessCustomer/GetDataUsage', async (data, thunkAPI) => {
  try {
    var result = await ProviderManager.getProviderData('GetDataUsage', [
      data.orgId ? data.orgId : '',
      data.selectedNumber,
      data.isPrivate,
      data.blockId,
      data.isRefresh,
      data.isBusiness,
    ]);
    return result.Body;
  } catch (error) {
    return {
      error: true,
    };
  }
});
export const ChangeClientName = createAsyncThunk('BussinessCustomer/ChangeClientName', async (data, thunkAPI) => {
  try {
    var result = await ProviderManager.getProviderData('ChangeClientName', [
      data.orgId ? data.orgId : '',
      data.selectedNumber,
      data.newFirstName,
      data.newLastName,
    ]);
    return result.Body;
  } catch (error) {
    return {
      error: true,
    };
  }
});
export const AddOrRemoveImeiAction = createAsyncThunk('BussinessCustomer/AddOrRemoveImei', async (data, thunkAPI) => {
  try {
    var result = await ProviderManager.getProviderData('AddOrRemoveImei', [
      data.orgId ?? '',
      data.selectedNumber,
      data.action,
      data.selectedImei,
      data.isSecondRound,
    ]);
    return result.Body;
  } catch (error) {
    return {
      error: true,
    };
  }
});
export const AddSurfingPackageForBusiness = createAsyncThunk('BussinessCustomer/AddSurfingPackageForBusiness', async (data, thunkAPI) => {
  try {
    var result = await ProviderManager.getProviderData('AddSurfingPackageForBusiness', [
      data.orgId ? data.orgId : '',
      data.subscriberNo,
      data.socBlockId,
    ]);
    return result.Body;
  } catch (error) {
    return {
      error: true,
    };
  }
});

export const CheckEsimClientStatus = createAsyncThunk('BussinessCustomer/CheckEsimClientStatus', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    var result = await ProviderManager.getProviderData('CheckEsimClientStatus', [
      data.chosenOrgNumber,
      data.userPhoneNumber,
      data.privateCompanyList,
    ]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      error: true,
    };
  }
});
export const GetRentSuspensionReasons = createAsyncThunk('BussinessCustomer/GetRentSuspensionReasons', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    var result = await ProviderManager.getProviderData('GetRentSuspensionReasons', [data.orgId ?? '']);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      error: true,
    };
  }
});

export const SendEmailRetriveQr = createAsyncThunk('BussinessCustomer/SendEmailRetriveQr', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    var result = await ProviderManager.getProviderData('SendEmailRetriveQr', [
      data.clientName,
      data.scopeName,
      data.isDynamic,
      data.sendSms,
      data.sendEmail,
      data.parameters,
    ]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      error: true,
    };
  }
});

export const GetQrCodeOrderInfo = createAsyncThunk('BussinessCustomer/GetQrCodeOrderInfo', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    var result = await ProviderManager.getProviderData('GetQrCodeOrderInfo', [data.subscriberNumber, data.contactOrgId]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      error: true,
    };
  }
});

export const SendQrCodeViaMagicLink = createAsyncThunk('BussinessCustomer/SendQrCodeViaMagicLink', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    var result = await ProviderManager.getProviderData('SendQrCodeViaMagicLink', [data.subscriberNumber, data.otpPhone, data.salesOrder]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      error: true,
    };
  }
});

export const GetTinyParameters = createAsyncThunk('BussinessCustomer/GetTinyParameters', async (data, thunkAPI) => {
  try {
    var result = await ProviderManager.getProviderData('GetTinyParameters', [data.params]);
    return result.Body;
  } catch (error) {
    return {
      error: true,
    };
  }
});

export const getOrganizationsDataForCompanies = createAsyncThunk(
  'BussinessCustomer/getOrganizationsDataForCompanies',
  async (bussinessOrgList) => {
    const results = await Promise.all(
      (bussinessOrgList || []).map(async (org) => {
        const orgId = org.orgId?.trim() || org.orgId;
        try {
          const result = await ProviderManager.getProviderData('getOrganizationData', [orgId]);
          const orgData = result.Body?.data || result.Body?.Data || null;
          return {orgId, data: orgData};
        } catch (e) {
          return {orgId, data: null};
        }
      }),
    );
    return results.reduce((map, item) => {
      map[item.orgId] = item.data;
      return map;
    }, {});
  },
);

export const LockUnlockNpStatus = createAsyncThunk('BussinessCustomer/LockUnlockNpStatus', async (data, thunkAPI) => {
  try {
    var result = await ProviderManager.getProviderData('LockUnlockNpStatus', [data.ban, data.subscriberNumber, data.actionType]);
    return result.Body;
  } catch (error) {
    return {
      error: true,
    };
  }
});

const buildSelectOptions = (orgList) => {
  const selectBox = [];
  orgList.forEach((org) => {
    let item = {key: org.idNumber, value: `${org.orgName} ${org.idNumber}`};
    selectBox.push(item);
  });
  return selectBox;
};

const portalSlice = createSlice({
  name: 'portal',
  initialState: {
    privateCompanyList: [],
    firstName: '',
    lastName: '',
    id: '',
    mobile: '',
    suspensionReasons: [],
    hetPaysNumbers: [],
    selectCompanyOptions: [],
    selectedHetPay: '',
    selectedHetPayId: '',
    selectedOrgName: '',
    portals: [],
    showScActions: true,
    allowedScActions: false,
    allowedCellular: false,
    allowedBusinessReports: false,
    allowedSuspendAction: false,
    allowedUploadOrgUsersList: false,
    canRenderPortals: false,
    selectedHetPayAllowedToActions: true,
    requestCompleted: false,
    isLoading: false,
    isShowPopup: false,
    isShowSocPopUp: false,
    skipSelectCompanyStep: false,
    customerPhoneNumber: null,
    customerSimNumber: null,
    customerNumber: null,
    formType: null,
    isSimSelected: false,
    selectedCustomerStep: '',
    selectedSubscriber: null,
    selectedOffer: null,
    addPackageSuccess: null,
    isIMEIEditMode: false,
    isIMEIAddMode: false,
    newIMEINumber: '',
    IMEIList: null,
    isImeiChangeSuccsess: false,
    isAddImei: false,
    isRemoveImei: false,
    banNumber: '',
    customerMail: '',
    companyOrgDataMap: {},
    isOrgDataLoading: false,
    subStatusDesc: '',
    financialStatusDesc: '',
    isRent: false,
  },
  reducers: {
    setSelectedHetPay: (state, action) => {
      let selectedHetPayAllData = state.privateCompanyList.find((company) => {
        if (company.idNumber?.trim() === action.payload?.trim()) {
          return company;
        }
      });

      state.selectedHetPay = action.payload;
      state.selectedHetPayId = selectedHetPayAllData?.orgId?.trim();
      state.selectedOrgName = selectedHetPayAllData?.orgName?.trim();
      state.portals = (state.privateCompanyList.find((c) => c.idNumber == action.payload) || {}).portalList || [];
      state.allowedScActions = (state.privateCompanyList.find((c) => c.idNumber == action.payload) || {}).allowedScActions;
      state.allowedCellular = (state.privateCompanyList.find((c) => c.idNumber == action.payload) || {}).allowedCellular;
      state.allowedBusinessReports = (state.privateCompanyList.find((c) => c.idNumber == action.payload) || {}).allowedBusinessReports;
      state.allowedUploadOrgUsersList = (
        state.privateCompanyList.find((c) => c.idNumber == action.payload) || {}
      ).allowedUploadOrgUsersList;
      state.isRent = (state.privateCompanyList.find((c) => c.idNumber == action.payload) || {}).isRent;
      return state;
    },
    setCustomerDetailCcr: (state, action) => {
      state.banNumber = action.payload.banNumber;
      state.customerMail = action.payload.customerMail;
      return state;
    },
    setIsIMEIEditMode: (state, action) => {
      state.isIMEIEditMode = action.payload;
      return state;
    },
    setIsImeiChangeSuccsess: (state, action) => {
      state.isImeiChangeSuccsess = action.payload.success;
      if (action.payload.success) {
        state.isAddImei = action.payload.isAdd;
        state.isRemoveImei = action.payload.isRemove;
      }
      return state;
    },
    setIsIMEIAddMode: (state, action) => {
      state.isIMEIAddMode = action.payload;
      return state;
    },
    setNewIMEINumber: (state, action) => {
      state.newIMEINumber = action.payload;
      return state;
    },
    setSelectedHetPayId: (state, action) => {
      state.selectedHetPayId = action.payload;
      return state;
    },
    skipSelectCompanyStep: (state, action) => {
      state.skipSelectCompanyStep = action.payload;
    },
    setAvailablePortals: (state, action) => {
      return {
        ...state,
        portals: action.payload,
      };
    },
    setIsShowPopup: (state, action) => {
      state.isShowPopup = action.payload;
      return state;
    },
    setIsShowSocPopUp: (state, action) => {
      state.isShowSocPopUp = action.payload;
      return state;
    },
    setSelectedOffer: (state, action) => {
      state.selectedOffer = action.payload;
    },
    setAddPackageSuccess: (state, action) => {
      state.addPackageSuccess = action.payload;
      return state;
    },
    setSelectedHetPayAllowedToActions: (state, action) => {
      state.selectedHetPayAllowedToActions = action.payload;
    },
    setCustomerNumber: (state, action) => {
      state.customerPhoneNumber = action.payload;
      state.customerNumber = action.payload;
    },
    setFormType: (state, action) => {
      state.formType = action.payload;
    },
    setSelectedSubscriber: (state, action) => {
      state.selectedSubscriber = action.payload;
    },
    setIsSimSelected: (state, action) => {
      state.isSimSelected = action.payload;
    },
    setCustomerSimNumber: (state, action) => {
      state.customerSimNumber = action.payload;
    },
    saveToHistory: (state, action) => {
      return state;
    },
    resetSuspensionReasons: (state, action) => {
      state.suspensionReasons = [];
    },
    reportDWH: (state, action) => {},
  },
  extraReducers: {
    [GetCustomerDetailsForBusinessContactManager.fulfilled]: (state, action) => {
      state.IMEIList = action.payload.imeiNumberList;
      state.IMEINumbersRepairInfo = action.payload.imeiNumbersRepairInfo
      state.subStatusDesc = action.payload.subStatusDesc;
      state.financialStatusDesc = action.payload.financialStatusDesc;
    },
    [AddOrRemoveImeiAction.fulfilled]: (state, action) => {
      if (action.payload.isRemoveSuccess || action.payload.isAddSuccess) state.IMEIList = action.payload.imeiList;
    },
    [suspendOrActivateBusinessAccount.fulfilled]: (state, action) => {
      if (action.payload.Msg == 'DTONLY') state.showDTONLY = true;
      else state.showDTONLY = false;
      state.isShowPopup = false;
    },
    [getContactCompanyList.pending]: (state, action) => {
      state.requestCompleted = false;
      state.isLoading = true;
    },
    [getContactCompanyList.fulfilled]: (state, action) => {
      if (!action.payload.error) {
        const HetPays = (action.payload.bussinessOrgList || [])
          .map((o) => {
            return {name: o.orgName, id: o.idNumber};
          })
          .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
        const hetPayCount = action.payload.bussinessOrgList.length === 1 ? action.payload.bussinessOrgList[0].portalList : [];
        const allowedScActions = action.payload.bussinessOrgList.length === 1 ? action.payload.bussinessOrgList[0].allowedScActions : false;
        const allowedCellular = action.payload.bussinessOrgList.length === 1 ? action.payload.bussinessOrgList[0].allowedCellular : false;
        const allowedBusinessReports =
          action.payload.bussinessOrgList.length === 1 ? action.payload.bussinessOrgList[0].allowedBusinessReports : false;
        const allowedSuspendAction =
          action.payload.bussinessOrgList.length === 1 ? action.payload.bussinessOrgList[0].allowedSuspendAction : false;

        const selected = action.payload.bussinessOrgList.length === 1 ? action.payload.bussinessOrgList[0] : null;

        state.privateCompanyList = action.payload.bussinessOrgList;
        state.firstName = action.payload.contactFirstName;
        state.lastName = action.payload.contactLastName;
        state.id = action.payload.contactId;
        state.mobile = action.payload.contactPhoneNumber;
        state.hetPaysNumbers = HetPays;
        state.portals = hetPayCount;
        state.allowedScActions = allowedScActions;
        state.allowedSuspendAction = allowedSuspendAction;
        state.allowedCellular = allowedCellular;
        state.allowedBusinessReports = allowedBusinessReports;
        state.selectedHetPay = selected?.idNumber || '';
        state.selectedHetPayId = selected?.orgId?.trim() || '';
        state.selectedOrgName = selected?.orgName || '';
        state.isRent = selected?.isRent ?? false;
        state.canRenderPortals = checkCanRenderPortals();
        state.requestCompleted = true;
        state.isLoading = false;
        state.selectCompanyOptions = action.payload.bussinessOrgList?.length > 0 ? buildSelectOptions(action.payload.bussinessOrgList) : [];
        return state;
      }
      return state;
    },
    [getContactCompanyList.rejected]: (state, action) => {
      state.isLoading = false;
      state.requestCompleted = false;
      return state;
    },
    [AddSurfingPackageForBusiness.rejected]: (state, action) => {
      state.addPackageSuccess = false;
      return state;
    },
    [getOrganizationsDataForCompanies.pending]: (state) => {
      state.isOrgDataLoading = true;
    },
    [getOrganizationsDataForCompanies.fulfilled]: (state, action) => {
      state.companyOrgDataMap = action.payload;
      state.isOrgDataLoading = false;
    },
    [getOrganizationsDataForCompanies.rejected]: (state) => {
      state.isOrgDataLoading = false;
    },
    [GetRentSuspensionReasons.fulfilled]: (state, action) => {
      state.suspensionReasons = action.payload?.reasons || [];
    },
  },
});

export const {
  setSelectedHetPay,
  setSelectedHetPayId,
  setAvailablePortals,
  setSelectedHetPayAllowedToActions,
  setIsShowPopup,
  setIsShowSocPopUp,
  skipSelectCompanyStep,
  setCustomerNumber,
  setFormType,
  setSelectedSubscriber,
  setSelectedOffer,
  setAddPackageSuccess,
  setIsSimSelected,
  setCustomerSimNumber,
  reportDWH,
  setIsIMEIEditMode,
  setIsIMEIAddMode,
  setNewIMEINumber,
  setIsImeiChangeSuccsess,
  setCustomerDetailCcr,
  resetSuspensionReasons,
  saveToHistory,
} = portalSlice.actions;
export default portalSlice.reducer;
